// extracted by mini-css-extract-plugin
module.exports = {"wrap":"xd","subtitle":"yd","contentWrap":"zd","imgWrap":"Ad","heading":"Bd","copy":"Cd"};